/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_rebalanceFee",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_deleverageFee",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_maxSwapSlippage",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_assetConverter",
                type: "address",
                internalType: "contract IAssetConverter",
            },
            {
                name: "_addressesProvider",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "addressesProvider",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "assetConverter",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IAssetConverter",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "canCompound",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "canDeleverage",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "canRebalance",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "cancelCompound",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "cancelDeleverage",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "cancelRebalance",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "deleverageFee",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "executeCompound",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "flashloanProvider",
                type: "address",
                internalType: "contract IERC3156FlashLender",
            },
            {
                name: "usdGasFee",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "executeDeleverage",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "flashloanProvider",
                type: "address",
                internalType: "contract IERC3156FlashLender",
            },
            {
                name: "usdGasFee",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "executeRebalance",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "flashloanProvider",
                type: "address",
                internalType: "contract IERC3156FlashLender",
            },
            {
                name: "usdGasFee",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "getConfiguredAutomations",
        inputs: [
            {
                name: "positions",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [
            {
                name: "rebalances",
                type: "tuple[]",
                internalType: "struct YLDRLeverageAutomations.ScheduledRebalance[]",
                components: [
                    {
                        name: "initialized",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "triggerLower",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "triggerUpper",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "newTicksDown",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "newTicksUp",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "recurring",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.RecurringRebalanceConfig",
                        components: [
                            {
                                name: "rangeConfig",
                                type: "tuple",
                                internalType: "struct YLDRLeverageAutomations.RangeConfig",
                                components: [
                                    {
                                        name: "rangeConfigType",
                                        type: "uint8",
                                        internalType: "enum YLDRLeverageAutomations.RangeConfigType",
                                    },
                                    {
                                        name: "ticksDown",
                                        type: "int24",
                                        internalType: "int24",
                                    },
                                    {
                                        name: "ticksUp",
                                        type: "int24",
                                        internalType: "int24",
                                    },
                                    {
                                        name: "sqrtPriceX96Down",
                                        type: "uint160",
                                        internalType: "uint160",
                                    },
                                    {
                                        name: "sqrtPriceX96Up",
                                        type: "uint160",
                                        internalType: "uint160",
                                    },
                                ],
                            },
                            {
                                name: "endConfig",
                                type: "tuple",
                                internalType: "struct YLDRLeverageAutomations.EndConfig",
                                components: [
                                    {
                                        name: "triggerType",
                                        type: "uint8",
                                        internalType: "enum YLDRLeverageAutomations.EndTriggerType",
                                    },
                                    {
                                        name: "count",
                                        type: "uint256",
                                        internalType: "uint256",
                                    },
                                    {
                                        name: "timestamp",
                                        type: "uint256",
                                        internalType: "uint256",
                                    },
                                ],
                            },
                            {
                                name: "active",
                                type: "bool",
                                internalType: "bool",
                            },
                        ],
                    },
                    {
                        name: "gasFeeConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                        components: [
                            {
                                name: "maxUsd",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "maxPositionPercent",
                                type: "uint256",
                                internalType: "uint256",
                            },
                        ],
                    },
                ],
            },
            {
                name: "deleverages",
                type: "tuple[]",
                internalType: "struct YLDRLeverageAutomations.ScheduledDeleverage[]",
                components: [
                    {
                        name: "initialized",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "triggerLower",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "triggerUpper",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "withdrawLiquidity",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "gasFeeConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                        components: [
                            {
                                name: "maxUsd",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "maxPositionPercent",
                                type: "uint256",
                                internalType: "uint256",
                            },
                        ],
                    },
                ],
            },
            {
                name: "compounds",
                type: "tuple[]",
                internalType: "struct YLDRLeverageAutomations.ScheduledCompound[]",
                components: [
                    {
                        name: "initialized",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "maxTotalFeePercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "maxSwapSlippage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "operator",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "owner",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "rebalanceFee",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "renounceOwnership",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "scheduledCompounds",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "initialized",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "maxTotalFeePercent",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "scheduledDeleverages",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "initialized",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "triggerLower",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "triggerUpper",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "withdrawLiquidity",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "gasFeeConfig",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                components: [
                    {
                        name: "maxUsd",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "maxPositionPercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "scheduledRebalances",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "initialized",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "triggerLower",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "triggerUpper",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "newTicksDown",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "newTicksUp",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "recurring",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.RecurringRebalanceConfig",
                components: [
                    {
                        name: "rangeConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.RangeConfig",
                        components: [
                            {
                                name: "rangeConfigType",
                                type: "uint8",
                                internalType: "enum YLDRLeverageAutomations.RangeConfigType",
                            },
                            {
                                name: "ticksDown",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "ticksUp",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "sqrtPriceX96Down",
                                type: "uint160",
                                internalType: "uint160",
                            },
                            {
                                name: "sqrtPriceX96Up",
                                type: "uint160",
                                internalType: "uint160",
                            },
                        ],
                    },
                    {
                        name: "endConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.EndConfig",
                        components: [
                            {
                                name: "triggerType",
                                type: "uint8",
                                internalType: "enum YLDRLeverageAutomations.EndTriggerType",
                            },
                            {
                                name: "count",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "timestamp",
                                type: "uint256",
                                internalType: "uint256",
                            },
                        ],
                    },
                    {
                        name: "active",
                        type: "bool",
                        internalType: "bool",
                    },
                ],
            },
            {
                name: "gasFeeConfig",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                components: [
                    {
                        name: "maxUsd",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "maxPositionPercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "setupCompound",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "maxTotalFeePercent",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setupDeleverage",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "triggerLower",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "triggerUpper",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "withdrawLiquidity",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "gasFeeConfig",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                components: [
                    {
                        name: "maxUsd",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "maxPositionPercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setupRebalance",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
            {
                name: "triggerLower",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "triggerUpper",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "newTicksDown",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "newTicksUp",
                type: "int24",
                internalType: "int24",
            },
            {
                name: "recurring",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.RecurringRebalanceConfig",
                components: [
                    {
                        name: "rangeConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.RangeConfig",
                        components: [
                            {
                                name: "rangeConfigType",
                                type: "uint8",
                                internalType: "enum YLDRLeverageAutomations.RangeConfigType",
                            },
                            {
                                name: "ticksDown",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "ticksUp",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "sqrtPriceX96Down",
                                type: "uint160",
                                internalType: "uint160",
                            },
                            {
                                name: "sqrtPriceX96Up",
                                type: "uint160",
                                internalType: "uint160",
                            },
                        ],
                    },
                    {
                        name: "endConfig",
                        type: "tuple",
                        internalType: "struct YLDRLeverageAutomations.EndConfig",
                        components: [
                            {
                                name: "triggerType",
                                type: "uint8",
                                internalType: "enum YLDRLeverageAutomations.EndTriggerType",
                            },
                            {
                                name: "count",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "timestamp",
                                type: "uint256",
                                internalType: "uint256",
                            },
                        ],
                    },
                    {
                        name: "active",
                        type: "bool",
                        internalType: "bool",
                    },
                ],
            },
            {
                name: "gasFeeConfig",
                type: "tuple",
                internalType: "struct YLDRLeverageAutomations.GasFeeConfig",
                components: [
                    {
                        name: "maxUsd",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "maxPositionPercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "transferOwnership",
        inputs: [
            {
                name: "newOwner",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "whitelistFlashloanProviders",
        inputs: [
            {
                name: "providers",
                type: "address[]",
                internalType: "contract IERC3156FlashLender[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "OwnershipTransferred",
        inputs: [
            {
                name: "previousOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "OwnableInvalidOwner",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "OwnableUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "R",
        inputs: [],
    },
    {
        type: "error",
        name: "T",
        inputs: [],
    },
];
const _bytecode = "0x60a06040523480156200001157600080fd5b5060405162004e4438038062004e44833981016040819052620000349162000119565b33806200005b57604051631e4fbdf760e01b81526000600482015260240160405180910390fd5b6200006681620000b0565b506001949094556003919091556002919091556001600160a01b0391821660805260048054919092166001600160a01b031991821617909155600680549091163317905562000175565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b03811681146200011657600080fd5b50565b600080600080600060a086880312156200013257600080fd5b8551945060208601519350604086015192506060860151620001548162000100565b6080870151909250620001678162000100565b809150509295509295909350565b608051614ca56200019f600039600081816102e8015281816126860152612dc90152614ca56000f3fe608060405234801561001057600080fd5b506004361061018e5760003560e01c8063a4c6c1e0116100de578063ed363df911610097578063f78317d911610071578063f78317d91461039f578063f8849096146103c1578063fab35222146103d4578063fff372a21461044a57600080fd5b8063ed363df914610366578063ee4790d614610379578063f2fde38b1461038c57600080fd5b8063a4c6c1e0146102da578063c72c4d10146102e3578063c84737931461030a578063da42a33c1461031d578063dbde19cc14610330578063dcf61a251461034357600080fd5b8063570ca7351161014b578063715018a611610125578063715018a6146102885780637f2586af14610290578063836ab5d0146102b65780638da5cb5b146102c957600080fd5b8063570ca735146102375780635d73efce146102625780636b96081b1461027557600080fd5b80630c6d95a21461019357806321d3534d146101a85780632e35bcca146101f1578063494f3f4b14610208578063553231951461021b578063561432ac14610224575b600080fd5b6101a66101a1366004613fb0565b61045d565b005b6101d56101b6366004613fb0565b6009602052600090815260409020805460019091015460ff9091169082565b6040805192151583526020830191909152015b60405180910390f35b6101fa60015481565b6040519081526020016101e8565b6101a6610216366004613fcd565b610499565b6101fa60035481565b6101a6610232366004613fb0565b6104e7565b60065461024a906001600160a01b031681565b6040516001600160a01b0390911681526020016101e8565b60045461024a906001600160a01b031681565b6101a6610283366004614123565b610515565b6101a6610733565b6102a361029e366004613fb0565b610747565b6040516101e89796959493929190614238565b6101a66102c4366004614290565b6108af565b6000546001600160a01b031661024a565b6101fa60025481565b61024a7f000000000000000000000000000000000000000000000000000000000000000081565b6101a661031836600461431a565b610c0e565b6101a661032b366004613fb0565b610fd6565b6101a661033e366004614290565b611064565b610356610351366004613fb0565b611185565b60405190151581526020016101e8565b6101a6610374366004614488565b611427565b6101a6610387366004614290565b611491565b6101a661039a366004613fb0565b611b82565b6103b26103ad366004614527565b611bc0565b6040516101e893929190614674565b6103566103cf366004613fb0565b612031565b6104396103e2366004613fb0565b60086020908152600091825260409182902080548351808501909452600182015484526002918201549284019290925260ff808316936101008404830b93600160201b810490930b92600160381b90049091169085565b6040516101e8959493929190614739565b610356610458366004613fb0565b61206f565b610466816121e9565b6001600160a01b03166000908152600860205260408120805467ffffffffffffffff191681556001810182905560020155565b6104a2826121e9565b604080518082018252600180825260208083019485526001600160a01b039590951660009081526009909552919093209251835460ff19169015151783559051910155565b6104f0816121e9565b6001600160a01b03166000908152600960205260408120805460ff1916815560010155565b61051e856121e9565b60008061052a876122ab565b915091506000826001600160a01b031663b34dd426836040518263ffffffff1660e01b815260040161055c9190614773565b602060405180830381865afa158015610579573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061059d9190614866565b60405163ec04205b60e01b81526001600160a01b03808316600483015291925060009185169063ec04205b906024016040805180830381865afa1580156105e8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061060c919061488e565b9150508060020b8860020b12801561062957508060020b8760020b135b61066f5760405162461bcd60e51b8152602060048201526012602482015271496e76616c6964207469636b2072616e676560701b60448201526064015b60405180910390fd5b50506040805160a0810182526001808252600298890b6020808401918252988a0b83850190815297151560608401908152608084019788526001600160a01b039b909b16600090815260088a529390932091518254935197519a5163ffffffff1990941690151563ffffff0019161761010062ffffff988916021767ffffffff000000001916600160201b97909a169690960267ff00000000000000191698909817600160381b911515919091021787555050518051918501919091550151910155565b61073b6124a1565b61074560006124ce565b565b600760205260009081526040908190208054825161010080820190945260018301805460ff808516968504600290810b96600160201b8704820b96600160381b8104830b96600160501b909104830b959194909391928492606084019285928492909116908111156107bb576107bb61418f565b60028111156107cc576107cc61418f565b815281546101008104600290810b602080850191909152600160201b8304820b6040808601919091526001600160a01b03600160381b9094048416606080870191909152600196870154909416608090950194909452948652825191820190925290850180549490930193909291839160ff169081111561084f5761084f61418f565b60018111156108605761086061418f565b815260018201546020808301919091526002909201546040918201529183526005939093015460ff16151591830191909152805180820190915260078401548152600890930154908301529087565b6108b761251e565b6108c082612584565b6001600160a01b0383166000908152600860209081526040808320815160a081018352815460ff808216151583526101008204600290810b84880152600160201b8304810b84870152600160381b9092041615156060830152835180850190945260018301548452909101549282019290925260808201529080610943866122ab565b915091506000826001600160a01b031663b34dd426836040518263ffffffff1660e01b81526004016109759190614773565b602060405180830381865afa158015610992573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109b69190614866565b60405163ec04205b60e01b81526001600160a01b03808316600483015291925060009185169063ec04205b906024016040805180830381865afa158015610a01573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a25919061488e565b915050610a3285826125f7565b610a775760405162461bcd60e51b815260206004820152601660248201527511195b195d995c9859d9481b9bdd08185b1b1bddd95960521b6044820152606401610666565b6000610a8d89868689608001518b600254612634565b9050886001600160a01b031663aef2223c896040518060800160405280600460009054906101000a90046001600160a01b03166001600160a01b0316815260200160035481526020018d6001600160a01b0316638da5cb5b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b14573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b389190614866565b6001600160a01b0390811682526060808d01511515602093840152604080516001600160e01b031960e089901b16815295831660048701528451831660248701529284015160448601529183015116606484015201511515608482015260a4810184905260c401600060405180830381600087803b158015610bb957600080fd5b505af1158015610bcd573d6000803e3d6000fd5b5050506001600160a01b039099166000908152600860205260408120805467ffffffffffffffff191681556001810182905560020155505050505050505050565b610c17876121e9565b600080610c23896122ab565b915091506000826001600160a01b031663b34dd426836040518263ffffffff1660e01b8152600401610c559190614773565b602060405180830381865afa158015610c72573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c969190614866565b60405163ec04205b60e01b81526001600160a01b03808316600483015291925060009185169063ec04205b906024016040805180830381865afa158015610ce1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d05919061488e565b9150508060020b8a60020b128015610d2257508060020b8960020b135b610d635760405162461bcd60e51b8152602060048201526012602482015271496e76616c6964207469636b2072616e676560701b6044820152606401610666565b6040518060e001604052806001151581526020018b60020b81526020018a60020b81526020018960020b81526020018860020b815260200187815260200186815250600760008d6001600160a01b03166001600160a01b0316815260200190815260200160002060008201518160000160006101000a81548160ff02191690831515021790555060208201518160000160016101000a81548162ffffff021916908360020b62ffffff16021790555060408201518160000160046101000a81548162ffffff021916908360020b62ffffff16021790555060608201518160000160076101000a81548162ffffff021916908360020b62ffffff160217905550608082015181600001600a6101000a81548162ffffff021916908360020b62ffffff16021790555060a08201518160010160008201518160000160008201518160000160006101000a81548160ff02191690836002811115610ec657610ec661418f565b021790555060208281015182546040850151606086015166ffffffffffff001990921661010062ffffff9485160266ffffff00000000191617600160201b939091169290920291909117600160381b600160d81b031916600160381b6001600160a01b0392831602178355608090930151600192830180546001600160a01b031916919094161790925590830151805160028401805492939092839160ff19909116908381811115610f7a57610f7a61418f565b02179055506020828101516001830155604092830151600290920191909155920151600591909101805460ff191691151591909117905560c0929092015180516007830155909101516008909101555050505050505050505050565b610fdf816121e9565b6001600160a01b03166000908152600760208190526040822080546cffffffffffffffffffffffffff191681556001810180546001600160d81b03191690556002810180546001600160a01b031916905560038101805460ff199081169091556004820184905560058201849055600682018054909116905590810182905560080155565b61106c61251e565b61107582612584565b61107e83612031565b6110c15760405162461bcd60e51b815260206004820152601460248201527310dbdb5c1bdd5b99081b9bdd08185b1b1bddd95960621b6044820152606401610666565b6001600160a01b0383166000908152600960205260408120600101546110ec90859085908590612dc4565b604080518082018252600480546001600160a01b0390811683526003546020840190815293516317f4708b60e01b8152888216928101929092529151821660248201529151604483015260648201839052919250908516906317f4708b90608401600060405180830381600087803b15801561116757600080fd5b505af115801561117b573d6000803e3d6000fd5b5050505050505050565b6000806000611193846122ab565b915091506000826001600160a01b031663b34dd426836040518263ffffffff1660e01b81526004016111c59190614773565b602060405180830381865afa1580156111e2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112069190614866565b60405163ec04205b60e01b81526001600160a01b03808316600483015291925060009185169063ec04205b906024016040805180830381865afa158015611251573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611275919061488e565b6001600160a01b038816600090815260076020908152604091829020825160e081018452815460ff80821615158352610100808304600290810b96850196909652600160201b8304860b84880152600160381b8304860b606080860191909152600160501b909304860b6080850152865190810190965260018401805497995061141d98509296939560a08801959094859384019285928492909116908111156113215761132161418f565b60028111156113325761133261418f565b815281546101008104600290810b602080850191909152600160201b8304820b6040808601919091526001600160a01b03600160381b9094048416606080870191909152600196870154909416608090950194909452948652825191820190925290850180549490930193909291839160ff16908111156113b5576113b561418f565b60018111156113c6576113c661418f565b815260018201546020808301919091526002909201546040918201529183526005939093015460ff1615159183019190915291835281518083019092526007840154825260089093015481840152910152826125f7565b9695505050505050565b61142f6124a1565b60005b815181101561148d57600160056000848481518110611453576114536148c8565b6020908102919091018101516001600160a01b03168252810191909152604001600020805460ff1916911515919091179055600101611432565b5050565b61149961251e565b6114a282612584565b6000806114ae856122ab565b6001600160a01b0387166000908152600760209081526040808320815160e081018352815460ff80821615158352610100808304600290810b97850197909752600160201b8304870b84870152600160381b8304870b606080860191909152600160501b909304870b60808501528551908101909552600184018054999b5097995095979196929560a0880195859392840192859284929116908111156115575761155761418f565b60028111156115685761156861418f565b815281546101008104600290810b602080850191909152600160201b8304820b6040808601919091526001600160a01b03600160381b9094048416606080870191909152600196870154909416608090950194909452948652825191820190925290850180549490930193909291839160ff16908111156115eb576115eb61418f565b60018111156115fc576115fc61418f565b815260018201546020808301919091526002909201546040918201529183526005939093015460ff161515918301919091529183528151808301835260078501548152600890940154848201529190910191909152516359a6ea1360e11b81529091506000908190819081906001600160a01b0388169063b34dd42690611687908990600401614773565b602060405180830381865afa1580156116a4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116c89190614866565b60405163ec04205b60e01b81526001600160a01b0380831660048301529192509088169063ec04205b906024016040805180830381865afa158015611711573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611735919061488e565b60405163595db1c160e01b81526001600160a01b038481166004830152919450600092509089169063595db1c190602401602060405180830381865afa158015611783573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117a791906148de565b90508560600151836117b99190614911565b94508560800151836117cb9190614936565b9350806117d88187614971565b6117e29083614936565b6117ec9190614971565b6117f69086614911565b9450806118038186614971565b61180d9083614911565b6118179190614971565b6118219085614936565b9350505061182f84826125f7565b6118735760405162461bcd60e51b8152602060048201526015602482015274149958985b185b98d9481b9bdd08185b1b1bddd959605a1b6044820152606401610666565b60006118898a88888860c001518c600154612634565b60408051608081018252600480546001600160a01b0390811683526003546020840152600289810b8486015288900b6060840152925163af04042960e01b8152939450918d169263af04042992611930928e9290918791016001600160a01b0393841681528251909316602080850191909152820151604080850191909152820151600290810b6060808601919091529092015190910b608083015260a082015260c00190565b600060405180830381600087803b15801561194a57600080fd5b505af115801561195e573d6000803e3d6000fd5b5050505060008060006119778860a0015186898961347e565b9250925092508215611a0c576001600160a01b038d166000908152600760208190526040822080546cffffffffffffffffffffffffff191681556001810180546001600160d81b03191690556002810180546001600160a01b031916905560038101805460ff199081169091556004820184905560058201849055600682018054909116905590810182905560080155611b73565b6001600160a01b038d166000908152600760205260409020805462ffffff838116600160201b0266ffffff0000000019918616610100029190911666ffffffffffff00199092169190911717815560a0890151805180516001938401805493949093849291839160ff191690836002811115611a8a57611a8a61418f565b021790555060208281015182546040850151606086015166ffffffffffff001990921661010062ffffff9485160266ffffff00000000191617600160201b939091169290920291909117600160381b600160d81b031916600160381b6001600160a01b0392831602178355608090930151600192830180546001600160a01b031916919094161790925590830151805160028401805492939092839160ff19909116908381811115611b3e57611b3e61418f565b02179055506020820151600182015560409182015160029091015591909101516005909101805460ff19169115159190911790555b50505050505050505050505050565b611b8a6124a1565b6001600160a01b038116611bb457604051631e4fbdf760e01b815260006004820152602401610666565b611bbd816124ce565b50565b6060806060835167ffffffffffffffff811115611bdf57611bdf61401d565b604051908082528060200260200182016040528015611c1857816020015b611c05613eea565b815260200190600190039081611bfd5790505b509250835167ffffffffffffffff811115611c3557611c3561401d565b604051908082528060200260200182016040528015611ca457816020015b611c916040805160a0810182526000808252602080830182905282840182905260608301829052835180850190945281845283015290608082015290565b815260200190600190039081611c535790505b509150835167ffffffffffffffff811115611cc157611cc161401d565b604051908082528060200260200182016040528015611d0657816020015b6040805180820190915260008082526020820152815260200190600190039081611cdf5790505b50905060005b84518110156120295760076000868381518110611d2b57611d2b6148c8565b6020908102919091018101516001600160a01b03168252818101929092526040908101600020815160e081018352815460ff80821615158352610100808304600290810b97850197909752600160201b8304870b84870152600160381b8304870b606080860191909152600160501b909304870b608085015285519081019095526001840180549396949560a088019590949193859390840192859284929190911690811115611ddd57611ddd61418f565b6002811115611dee57611dee61418f565b815281546101008104600290810b602080850191909152600160201b8304820b6040808601919091526001600160a01b03600160381b9094048416606080870191909152600196870154909416608090950194909452948652825191820190925290850180549490930193909291839160ff1690811115611e7157611e7161418f565b6001811115611e8257611e8261418f565b815260018201546020808301919091526002909201546040918201529183526005939093015460ff16151591830191909152918352815180830190925260078401548252600890930154818401529101528451859083908110611ee757611ee76148c8565b602002602001018190525060086000868381518110611f0857611f086148c8565b6020908102919091018101516001600160a01b03168252818101929092526040908101600020815160a081018352815460ff808216151583526101008204600290810b84880152600160201b8304810b84870152600160381b9092041615156060830152835180850190945260018301548452909101549282019290925260808201528351849083908110611f9f57611f9f6148c8565b602002602001018190525060096000868381518110611fc057611fc06148c8565b6020908102919091018101516001600160a01b031682528181019290925260409081016000208151808301909252805460ff161515825260010154918101919091528251839083908110612016576120166148c8565b6020908102919091010152600101611d0c565b509193909250565b6001600160a01b03166000908152600960209081526040918290208251808401909352805460ff161515808452600190910154929091019190915290565b600080600061207d846122ab565b915091506000826001600160a01b031663b34dd426836040518263ffffffff1660e01b81526004016120af9190614773565b602060405180830381865afa1580156120cc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906120f09190614866565b60405163ec04205b60e01b81526001600160a01b03808316600483015291925060009185169063ec04205b906024016040805180830381865afa15801561213b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061215f919061488e565b6001600160a01b038816600090815260086020908152604091829020825160a081018452815460ff808216151583526101008204600290810b84870152600160201b8304810b84880152600160381b90920416151560608301528451808601909552600183015485529091015491830191909152608081019190915290925061141d9150826125f7565b336001600160a01b0316816001600160a01b0316638da5cb5b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612231573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122559190614866565b6001600160a01b031614611bbd5760405162461bcd60e51b815260206004820152601e60248201527f4f6e6c79206f776e65722063616e20736574757020726562616c616e636500006044820152606401610666565b6040805161016081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810182905260e08101829052610100810182905261012081018290526101408101829052826001600160a01b031663721c18556040518163ffffffff1660e01b8152600401602060405180830381865afa158015612341573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123659190614866565b6001600160a01b03166303eadcfc6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156123a2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123c69190614866565b91506000836001600160a01b031663ceefe5d16040518163ffffffff1660e01b8152600401602060405180830381865afa158015612408573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061242c9190614993565b604051630f415acb60e01b8152600481018290529091506001600160a01b03841690630f415acb9060240161016060405180830381865afa158015612475573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061249991906149d6565b915050915091565b6000546001600160a01b031633146107455760405163118cdaa760e01b8152336004820152602401610666565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6006546001600160a01b031633146107455760405162461bcd60e51b8152602060048201526024808201527f4f6e6c79206f70657261746f722063616e2063616c6c20746869732066756e636044820152633a34b7b760e11b6064820152608401610666565b6001600160a01b03811660009081526005602052604090205460ff16611bbd5760405162461bcd60e51b815260206004820152602260248201527f466c6173686c6f616e2070726f7669646572206e6f742077686974656c697374604482015261195960f21b6064820152608401610666565b81516000906126085750600061262e565b8160020b836020015160020b12158061262b57508160020b836040015160020b13155b90505b92915050565b6040805161014081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810182905260e08101829052610100810182905261012081018290527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663fca513a86040518163ffffffff1660e01b8152600401602060405180830381865afa1580156126e2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127069190614866565b6001600160a01b03908116825260408051636388666b60e11b81529051918a169163c710ccd6916004808201926020929091908290030181865afa158015612752573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127769190614866565b6001600160a01b0390811660208301819052825160405163b3596f0760e01b815260048101929092529091169063b3596f0790602401602060405180830381865afa1580156127c9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127ed9190614993565b81604001818152505080602001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015612838573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061285c9190614a9d565b60ff166060820152604080516314a6bf0f60e01b815290516001600160a01b038a16916314a6bf0f9160048083019260209291908290030181865afa1580156128a9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128cd9190614993565b60808201528451600090156128e457508451612d22565b6040516359a6ea1360e11b81526001600160a01b0389169063b34dd42690612910908a90600401614773565b602060405180830381865afa15801561292d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906129519190614866565b6001600160a01b0390811660c0840181905260405163ec04205b60e01b815260048101919091529089169063ec04205b906024016040805180830381865afa1580156129a1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906129c5919061488e565b506001600160a01b031660e0830181905260a0880151612a0091906129e9906136bf565b6129f68a60c001516136bf565b8a608001516139e1565b6101208401526101008301526040516309b09aad60e41b815260009081906001600160a01b038b1690639b09aad090612a3d908c90600401614773565b6040805180830381865afa158015612a59573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612a7d9190614ac0565b91509150818461010001818151612a949190614ae4565b90525061012084018051829190612aac908390614ae4565b905250835160208a015160405163b3596f0760e01b81526001600160a01b039182166004820152600092919091169063b3596f0790602401602060405180830381865afa158015612b01573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b259190614993565b85516040808d0151905163b3596f0760e01b81526001600160a01b03918216600482015292935060009291169063b3596f0790602401602060405180830381865afa158015612b78573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b9c9190614993565b905060008660600151600a612bb19190614bdb565b87604001518860800151612bc59190614bea565b612bcf9190614c01565b8c604001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015612c11573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c359190614a9d565b612c4090600a614bdb565b83896101200151612c519190614bea565b612c5b9190614c01565b8d602001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015612c9d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612cc19190614a9d565b612ccc90600a614bdb565b858a6101000151612cdd9190614bea565b612ce79190614c01565b612cf19190614ae4565b612cfb9190614c15565b90506127108b6020015182612d109190614bea565b612d1a9190614c01565b955050505050505b80851115612d655760405162461bcd60e51b815260206004820152601060248201526f08ec2e640cccaca40e8dede40d0d2ced60831b6044820152606401610666565b612710826080015185612d789190614bea565b612d829190614c01565b8260400151868460600151600a612d999190614bdb565b612da39190614bea565b612dad9190614c01565b612db79190614ae4565b9998505050505050505050565b6000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663fca513a86040518163ffffffff1660e01b8152600401602060405180830381865afa158015612e25573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612e499190614866565b90506000866001600160a01b031663c710ccd66040518163ffffffff1660e01b8152600401602060405180830381865afa158015612e8b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612eaf9190614866565b9050600080612ebd896122ab565b915091506000806000846001600160a01b0316639b09aad0856040518263ffffffff1660e01b8152600401612ef29190614773565b6040805180830381865afa158015612f0e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f329190614ac0565b91509150600084602001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015612f7a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f9e9190614a9d565b612fa990600a614bdb565b602086015160405163b3596f0760e01b81526001600160a01b039182166004820152908a169063b3596f0790602401602060405180830381865afa158015612ff5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130199190614993565b6130239085614bea565b61302d9190614c01565b9050600085604001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015613073573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130979190614a9d565b6130a290600a614bdb565b604087810151905163b3596f0760e01b81526001600160a01b039182166004820152908b169063b3596f0790602401602060405180830381865afa1580156130ee573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131129190614993565b61311c9085614bea565b6131269190614c01565b90506131328183614ae4565b60405163b3596f0760e01b81526001600160a01b038a8116600483015291965060009550908a16935063b3596f0792506024019050602060405180830381865afa158015613184573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131a89190614993565b856001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa1580156131e6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061320a9190614a9d565b61321590600a614bdb565b61321f908b614bea565b6132299190614c01565b905060008a6001600160a01b031663d9d98ce487848f6001600160a01b03166314a6bf0f6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561327c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906132a09190614993565b6132aa9190614ae4565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381865afa1580156132f3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133179190614993565b90506000866001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015613359573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061337d9190614a9d565b61338890600a614bdb565b60405163b3596f0760e01b81526001600160a01b0389811660048301528a169063b3596f0790602401602060405180830381865afa1580156133ce573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133f29190614993565b6133fc9084614bea565b6134069190614c01565b90506000846134158d84614ae4565b61342190612710614bea565b61342b9190614c01565b90508a81111561346c5760405162461bcd60e51b815260206004820152600c60248201526b08ccaca40e8dede40d0d2ced60a31b6044820152606401610666565b50919c9b505050505050505050505050565b6000806000866040015161349b57506001915060009050806136b5565b600060208801515160018111156134b4576134b461418f565b036134f657600187602001516020018181516134d09190614c15565b90525060208088015101516000036134f157506001915060009050806136b5565b613532565b6001602088015151600181111561350f5761350f61418f565b0361353257866020015160400151421061353257506001915060009050806136b5565b600087515160028111156135485761354861418f565b0361357b578651602001516000906135609088614911565b8851604001516135709089614936565b9250925092506136b5565b600187515160028111156135915761359161418f565b036136815760006135a1876136bf565b905060006135b46401000276a383614c28565b6001600160a01b03168960000151606001516001600160a01b031611156135e0576401000276a36135f0565b8851606001516135f09083614c28565b905060006136128373fffd8963efd1fc6a506488495d951d5263988d26614c28565b6001600160a01b03168a60000151608001516001600160a01b0316111561364d5773fffd8963efd1fc6a506488495d951d5263988d2661365d565b89516080015161365d9084614c4f565b9050600061366a83613a7d565b61367383613a7d565b9550955095505050506136b5565b600287515160028111156136975761369761418f565b036136aa575060009150839050826136b5565b506001915060009050805b9450945094915050565b60008060008360020b126136d6578260020b6136de565b8260020b6000035b9050620d89e8811115613704576040516315e4079d60e11b815260040160405180910390fd5b60008160011660000361371b57600160801b61372d565b6ffffcb933bd6fad37aa2d162d1a5940015b70ffffffffffffffffffffffffffffffffff1690506002821615613761576ffff97272373d413259a46990580e213a0260801c5b6004821615613780576ffff2e50f5f656932ef12357cf3c7fdcc0260801c5b600882161561379f576fffe5caca7e10e4e61c3624eaa0941cd00260801c5b60108216156137be576fffcb9843d60f6159c9db58835c9266440260801c5b60208216156137dd576fff973b41fa98c081472e6896dfb254c00260801c5b60408216156137fc576fff2ea16466c96a3843ec78b326b528610260801c5b608082161561381b576ffe5dee046a99a2a811c461f1969c30530260801c5b61010082161561383b576ffcbe86c7900a88aedcffc83b479aa3a40260801c5b61020082161561385b576ff987a7253ac413176f2b074cf7815e540260801c5b61040082161561387b576ff3392b0822b70005940c7a398e4b70f30260801c5b61080082161561389b576fe7159475a2c29b7443b29c7fa6e889d90260801c5b6110008216156138bb576fd097f3bdfd2022b8845ad8f792aa58250260801c5b6120008216156138db576fa9f746462d870fdf8a65dc1f90e061e50260801c5b6140008216156138fb576f70d869a156d2a1b890bb3df62baf32f70260801c5b61800082161561391b576f31be135f97d08fd981231505542fcfa60260801c5b6201000082161561393c576f09aa508b5b7a84e1c677de54f3e99bc90260801c5b6202000082161561395c576e5d6af8dedb81196699c329225ee6040260801c5b6204000082161561397b576d2216e584f5fa1ea926041bedfe980260801c5b62080000821615613998576b048a170391f7dc42444e8fa20260801c5b60008460020b13156139b95780600019816139b5576139b561495b565b0490505b600160201b8106156139cc5760016139cf565b60005b60ff16602082901c0192505050919050565b600080836001600160a01b0316856001600160a01b03161115613a02579293925b846001600160a01b0316866001600160a01b031611613a2d57613a26858585613d7c565b9150613a74565b836001600160a01b0316866001600160a01b03161015613a6657613a52868585613d7c565b9150613a5f858785613ded565b9050613a74565b613a71858585613ded565b90505b94509492505050565b60006401000276a36001600160a01b03831610801590613ab9575073fffd8963efd1fc6a506488495d951d5263988d266001600160a01b038316105b613ad6576040516324c070df60e11b815260040160405180910390fd5b640100000000600160c01b03602083901b166001600160801b03811160071b81811c67ffffffffffffffff811160061b90811c63ffffffff811160051b90811c61ffff811160041b90811c60ff8111600390811b91821c600f811160021b90811c918211600190811b92831c97908811961790941790921717909117171760808110613b6a57607f810383901c9150613b74565b80607f0383901b91505b908002607f81811c60ff83811c9190911c800280831c81831c1c800280841c81841c1c800280851c81851c1c800280861c81861c1c800280871c81871c1c800280881c81881c1c800280891c81891c1c8002808a1c818a1c1c8002808b1c818b1c1c8002808c1c818c1c1c8002808d1c818d1c1c8002808e1c9c81901c9c909c1c80029c8d901c9e9d607f198f0160401b60c09190911c678000000000000000161760c19b909b1c674000000000000000169a909a1760c29990991c672000000000000000169890981760c39790971c671000000000000000169690961760c49590951c670800000000000000169490941760c59390931c670400000000000000169290921760c69190911c670200000000000000161760c79190911c600160381b161760c89190911c6680000000000000161760c99190911c6640000000000000161760ca9190911c6620000000000000161760cb9190911c6610000000000000161760cc9190911c6608000000000000161760cd9190911c66040000000000001617693627a301d71055774c8581026f028f6481ab7f045a5af012a19d003aa9198101608090811d906fdb2df09e81959a81455e260799a0632f8301901d600281810b9083900b14613d7057886001600160a01b0316613d55826136bf565b6001600160a01b03161115613d6a5781612db7565b80612db7565b50979650505050505050565b6000826001600160a01b0316846001600160a01b03161115613d9c579192915b836001600160a01b0316613dd5606060ff16846001600160801b0316901b8686036001600160a01b0316866001600160a01b0316613e38565b81613de257613de261495b565b0490505b9392505050565b6000826001600160a01b0316846001600160a01b03161115613e0d579192915b613e30826001600160801b03168585036001600160a01b0316600160601b613e38565b949350505050565b6000808060001985870985870292508281108382030391505080600003613e715760008411613e6657600080fd5b508290049050613de6565b808411613e7d57600080fd5b6000848688096000868103871696879004966002600389028118808a02820302808a02820302808a02820302808a02820302808a02820302808a02909103029181900381900460010186841190950394909402919094039290920491909117919091029150509392505050565b6040805160e08101825260008082526020820181905291810182905260608101829052608081019190915260a08101613f746040805161010081018252600060608083018281526080840183905260a0840183905260c0840183905260e0840183905283528351908101845281815260208082018390528185018390528301529181019190915290565b8152602001613f96604051806040016040528060008152602001600081525090565b905290565b6001600160a01b0381168114611bbd57600080fd5b600060208284031215613fc257600080fd5b8135613de681613f9b565b60008060408385031215613fe057600080fd5b8235613feb81613f9b565b946020939093013593505050565b8060020b8114611bbd57600080fd5b8035801515811461401857600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b6040516060810167ffffffffffffffff811182821017156140565761405661401d565b60405290565b60405160a0810167ffffffffffffffff811182821017156140565761405661401d565b604051610160810167ffffffffffffffff811182821017156140565761405661401d565b604051601f8201601f1916810167ffffffffffffffff811182821017156140cc576140cc61401d565b604052919050565b6000604082840312156140e657600080fd5b6040516040810181811067ffffffffffffffff821117156141095761410961401d565b604052823581526020928301359281019290925250919050565b600080600080600060c0868803121561413b57600080fd5b853561414681613f9b565b9450602086013561415681613ff9565b9350604086013561416681613ff9565b925061417460608701614008565b915061418387608088016140d4565b90509295509295909350565b634e487b7160e01b600052602160045260246000fd5b80518051600381106141b9576141b961418f565b80845250602081015160020b6020840152604081015160020b6040840152606081015160018060a01b03808216606086015280608084015116608086015250505060208101518051600281106142115761421161418f565b60a0840152602081015160c084015260409081015160e08401520151151561010090910152565b8715158152600287810b602083015286810b604083015285810b606083015284900b6080820152610200810161427160a08301856141a5565b82516101c083015260208301516101e083015298975050505050505050565b6000806000606084860312156142a557600080fd5b83356142b081613f9b565b925060208401356142c081613f9b565b929592945050506040919091013590565b6000606082840312156142e357600080fd5b6142eb614033565b90508135600281106142fc57600080fd5b80825250602082013560208201526040820135604082015292915050565b600080600080600080600087890361020081121561433757600080fd5b883561434281613f9b565b9750602089013561435281613ff9565b9650604089013561436281613ff9565b9550606089013561437281613ff9565b9450608089013561438281613ff9565b9350609f19016101208082121561439857600080fd5b6143a0614033565b60a08312156143ae57600080fd5b6143b661405c565b925060a08b0135600381106143ca57600080fd5b835260c08b01356143da81613ff9565b602084015260e08b01356143ed81613ff9565b60408401526101008b013561440181613f9b565b6060840152908a01359061441482613f9b565b81608084015282815261442b8c6101408d016142d1565b602082015261443d6101a08c01614008565b6040820152809450505050614456896101c08a016140d4565b905092959891949750929550565b600067ffffffffffffffff82111561447e5761447e61401d565b5060051b60200190565b6000602080838503121561449b57600080fd5b823567ffffffffffffffff8111156144b257600080fd5b8301601f810185136144c357600080fd5b80356144d66144d182614464565b6140a3565b81815260059190911b820183019083810190878311156144f557600080fd5b928401925b8284101561451c57833561450d81613f9b565b825292840192908401906144fa565b979650505050505050565b6000602080838503121561453a57600080fd5b823567ffffffffffffffff81111561455157600080fd5b8301601f8101851361456257600080fd5b80356145706144d182614464565b81815260059190911b8201830190838101908783111561458f57600080fd5b928401925b8284101561451c5783356145a781613f9b565b82529284019290840190614594565b60008151808452602080850194506020840160005b8381101561462b57815180511515885283810151600290810b858a015260408083015190910b908901526060808201511515908901526080908101518051918901919091526020015160a088015260c090960195908201906001016145cb565b509495945050505050565b60008151808452602080850194506020840160005b8381101561462b578151805115158852830151838801526040909601959082019060010161464b565b6060808252845182820181905260009190608090818501906020808a01865b8381101561470d57815180511515865283810151600290810b85880152604080830151820b9088015288820151810b8988015287820151900b8787015260a0808201516146e2828901826141a5565b505060c0015180516101c0870152602001516101e08601526102009094019390820190600101614693565b50505050848103602086015261472381886145b6565b92505050828103604084015261141d8185614636565b8515158152600285810b602083015284900b6040820152821515606082015260c0810161141d608083018480518252602090810151910152565b81518152602080830151610160830191614797908401826001600160a01b03169052565b5060408301516147b260408401826001600160a01b03169052565b5060608301516147c9606084018262ffffff169052565b5060808301516147e460808401826001600160801b03169052565b5060a08301516147f960a084018260020b9052565b5060c083015161480e60c084018260020b9052565b5060e083015161482960e08401826001600160801b03169052565b50610100838101516001600160801b031690830152610120808401519083015261014092830151929091019190915290565b805161401881613f9b565b60006020828403121561487857600080fd5b8151613de681613f9b565b805161401881613ff9565b600080604083850312156148a157600080fd5b82516148ac81613f9b565b60208401519092506148bd81613ff9565b809150509250929050565b634e487b7160e01b600052603260045260246000fd5b6000602082840312156148f057600080fd5b8151613de681613ff9565b634e487b7160e01b600052601160045260246000fd5b600282810b9082900b03627fffff198112627fffff8213171561262e5761262e6148fb565b600281810b9083900b01627fffff8113627fffff198212171561262e5761262e6148fb565b634e487b7160e01b600052601260045260246000fd5b60008260020b806149845761498461495b565b808360020b0791505092915050565b6000602082840312156149a557600080fd5b5051919050565b805162ffffff8116811461401857600080fd5b80516001600160801b038116811461401857600080fd5b600061016082840312156149e957600080fd5b6149f161407f565b82518152614a016020840161485b565b6020820152614a126040840161485b565b6040820152614a23606084016149ac565b6060820152614a34608084016149bf565b6080820152614a4560a08401614883565b60a0820152614a5660c08401614883565b60c0820152614a6760e084016149bf565b60e0820152610100614a7a8185016149bf565b908201526101208381015190820152610140928301519281019290925250919050565b600060208284031215614aaf57600080fd5b815160ff81168114613de657600080fd5b60008060408385031215614ad357600080fd5b505080516020909101519092909150565b8082018082111561262e5761262e6148fb565b600181815b80851115614b32578160001904821115614b1857614b186148fb565b80851615614b2557918102915b93841c9390800290614afc565b509250929050565b600082614b495750600161262e565b81614b565750600061262e565b8160018114614b6c5760028114614b7657614b92565b600191505061262e565b60ff841115614b8757614b876148fb565b50506001821b61262e565b5060208310610133831016604e8410600b8410161715614bb5575081810a61262e565b614bbf8383614af7565b8060001904821115614bd357614bd36148fb565b029392505050565b600061262b60ff841683614b3a565b808202811582820484141761262e5761262e6148fb565b600082614c1057614c1061495b565b500490565b8181038181111561262e5761262e6148fb565b6001600160a01b03828116828216039080821115614c4857614c486148fb565b5092915050565b6001600160a01b03818116838216019080821115614c4857614c486148fb56fea2646970667358221220caefd89866d371ec104f4125f7ea60edb203c79fae928d06c3fdb7bf61ff055464736f6c63430008170033";
const isSuperArgs = (xs) => xs.length > 1;
export class YLDRLeverageAutomations__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_rebalanceFee, _deleverageFee, _maxSwapSlippage, _assetConverter, _addressesProvider, overrides) {
        return super.deploy(_rebalanceFee, _deleverageFee, _maxSwapSlippage, _assetConverter, _addressesProvider, overrides || {});
    }
    getDeployTransaction(_rebalanceFee, _deleverageFee, _maxSwapSlippage, _assetConverter, _addressesProvider, overrides) {
        return super.getDeployTransaction(_rebalanceFee, _deleverageFee, _maxSwapSlippage, _assetConverter, _addressesProvider, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
YLDRLeverageAutomations__factory.bytecode = _bytecode;
YLDRLeverageAutomations__factory.abi = _abi;
//# sourceMappingURL=YLDRLeverageAutomations__factory.js.map